import React from "react";
import ResponsiveImage from "../../../../components/elements/ResponsiveImage";

const ImageBlock = ({config}) => {

    if (!config?.src) {
        return null;
    }

    return (
        <div className="w-full flex justify-center">
            <ResponsiveImage
                isPublic={false}
                src={config.src}
                alt={config.alt || ""}
                className="max-w-full h-auto rounded-xl object-contain"
            />
        </div>
    );
};

export default ImageBlock;